import Send from './Send'

export default Send
// eslint-disable-next-line import/export
export * from './Send'
